// tuning.ts — THE numbers file. Phase 7 balance edits land here (and in
// data/zones/*). If a balance change needs to touch code, that is an
// architecture bug — fix the architecture.

export const TUNING = {
  player: {
    maxHp: 100,
    speed: 150,              // px/s
    radius: 10,
    dashSpeed: 520,
    dashSeconds: 0.16,
    dashIframes: 0.15,
    dashCharges: 1,
    dashRecharge: 3.5,
    contactIframes: 0.6,     // post-hit grace
    potionCap: 1,
    potionDamage: 40,
    potionRadius: 260,
    foodHeal: 25,
    fountainHeal: 40,
  },

  weapons: {
    cinderblade: { damage: 22, swingArc: 2.1, range: 46, cooldown: 0.32, special: { cooldown: 8, damage: 30, dashLen: 140, trailSeconds: 8, trailDps: 10 } },
    whisperbow:  { damage: 9,  speed: 460, pierce: 1, cooldown: 0.2, moveMul: 1.08, special: { cooldown: 6, count: 5, spreadDeg: 40, knockback: 140 } },
    stormstaff:  { damage: 16, splash: 8, splashRadius: 42, speed: 320, cooldown: 0.42, special: { cooldown: 10, damage: 24, radius: 200, growSeconds: 0.5 } },
    bulwarkmaul: { damage: 34, swingArc: 2.6, range: 68, cooldown: 0.55, stagger: 0.8, crumpleMul: 1.45, damageTakenMul: 0.75, special: { cooldown: 7, blockSeconds: 3, shoveDamage: 12, shoveForce: 320, reflectDamage: 14 } },
  },

  gloom: {
    restlessAt: 0.5,        // generators +25% rate
    seethingAt: 0.75,       // enemies +15% speed, caps +25%
    restlessRateMul: 1.25,
    seethingSpeedMul: 1.15,
    seethingCapMul: 1.25,
    arrivalTrickleSeconds: 2.2,  // gloomspawn interval at 100%, shrinks slowly
    trickleAccel: 0.985,         // interval *= this per spawn
  },

  bosses: {
    burstCapWindowSeconds: 3,
    burstCapFraction: 0.18,  // max fraction of maxHp deletable per rolling window
    victory: {
      seconds: 2.4,          // kill -> payout card: the celebration owns this window
      bursts: 6,             // staged gold bursts across it
    },
  },

  elites: {
    baseRate: 0.08,
    shielded: { unlockRadiusTiles: 3 },
    frenzied: { speedMul: 1.4 },
    gloomtouched: { spawnCount: 3 },
    bloated: { hpMul: 1.8, speedMul: 0.8 },
  },

  economy: {
    goldSmall: 5,
    roomClearEmbers: [3, 6] as [number, number],
    bossEmbers: [25, 35, 45, 55, 70, 110],     // per zone index (1-based -1)
    bossGold: [40, 55, 70, 85, 100, 0],
    vaultGold: 80,
    vaultEmbers: 15,
    huskSealEmber: 1,
    altarRelicCost: [60, 80, 110],             // by rarity
    altarFoodCost: 25,
    altarPotionCost: 45,
  },

  zoneStatScale: { hpPerZone: 1.12, damagePerZone: 1.10 },

  run: {
    respiteFountainUses: 1,
    bossRelicChoices: 3,
    altarRelicChoices: 2,   // 3 with Curator shrine node
    zoneParSeconds: [240, 360] as [number, number],  // the directive's 4–6 min band
  },

  fx: {
    hitstopKill: 0.045,
    hitstopHit: 0.018,
    hitstopBoss: 0.09,
    shakeHit: 3,
    shakeExplosion: 7,
  },
} as const
